import { Component, OnInit } from '@angular/core';
import { ICardlistData } from '../../../../../shared/components/card-list/card-list.component';
import { NoDataActionType } from '../../../../../shared/interfaces/no-data';
import { CustomDashboardsService } from '../../../../services/my-limegear.service';
import { SmallMediumCardService } from '../../services/small-medium-card.service';

@Component({
    selector: 'top-lead-sources-lgc',
    templateUrl: './top-lead-sources-lgc.component.html',
    styleUrls: ['./top-lead-sources-lgc.component.scss'],
})
export class TopLeadSourcesLgcComponent implements OnInit {
    constructor(
        private _customDashboardsService: CustomDashboardsService,
        private _smallcardService: SmallMediumCardService
    ) {}

    leadsPartnersLargeCard: ICardlistData;

    ngOnInit() {
        this.leadsPartnersLargeCard = {
            cardId: 'leadSources',
            type: null,
            cardTitle: 'Top 10 Lead Sources',
            hideViewAll: false,
            dataTableData: [],
            searchTerm: '',
            action: NoDataActionType.pageStart,
        };

        this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
            this.leadsPartnersLargeCard = this._smallcardService.initializeTableCard(
                this.leadsPartnersLargeCard
            );
            this._smallcardService.prepareLeadsAndPartnersLargecardData(
                this.leadsPartnersLargeCard,
                changes.displayOptions,
                changes.hierarchyfilters,
                changes.action
            );
        });
    }
}
